import { Collapse } from '@material-ui/core';
import { calcInventoryItemDetailRoute, calcProductCatalogDetailRoute } from 'app/main/inventoryManagement/routes';
import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { TextLinkButtonWithExpandIcon } from 'framework/components/buttons/TextLinkButtonWithExpandIcon';
import { useThemeColor } from 'framework/components/color/useThemeColor';
import { formatCurrency } from 'framework/utils/formatCurrency';
import { ISalesLine } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { SalesCreditChipOrFragment } from '../components/SalesCreditChipOrFragment';
import { SalesLineStatusIcon } from './SalesLineStatusIcon';
import { mapSalesLineToColorX } from './utils';

const MajorFontSize = 16;
const MinorFontSize = 13;

interface IProps {
	line: ISalesLine;
	withoutBorder?: boolean;
	isExpanded: boolean;
	toggle: VoidFunction;
}

export const SalesLineListItem = ({ line, withoutBorder, isExpanded, toggle }: IProps) => {
	const strings = useLocalization();
	const { push } = useHistory();
	const color = useMemo(() => mapSalesLineToColorX(line), [line]);
	const tColor = useThemeColor(color);

	return (
		<div
			className='df-row w100'
			style={{
				borderBottom: withoutBorder === true ? 'unset' : '1px solid rgba(224, 224, 224, 1)',
				padding: '12px 0px',
			}}>
			<div style={{ marginRight: 8, color: tColor, fontSize: 22 }}>
				<SalesLineStatusIcon
					item={line}
					style={{ fontSize: 22, color: tColor }}
				/>
			</div>
			<div className='df-col fg1 gap-4'>
				{line.hasProductCatalogItem === true && (
					<TextLinkButton
						onClick={() => {
							if (line.inventoryItemId) {
								push(calcInventoryItemDetailRoute(line.inventoryItemId));
							} else if (line.productCatalogItemId) {
								push(calcProductCatalogDetailRoute(line.productCatalogItemId));
							}
						}}
						style={{ fontSize: MajorFontSize }}>
						{`${line.quantity} x ${line.description}`}
					</TextLinkButton>
				)}
				{line.hasProductCatalogItem === false && <span style={{ fontSize: MajorFontSize }}>{`${line.quantity} x ${line.description}`}</span>}
				<SalesCreditChipOrFragment
					item={line}
					style={{ width: 'fit-content' }}
				/>
				<TextLinkButtonWithExpandIcon
					toggle={toggle}
					isExpanded={isExpanded}>
					<span style={{ fontSize: MinorFontSize, fontWeight: 'unset' }}>
						{`${line.vatPercentage}% ${strings.vat}, ${formatCurrency(line.linePriceInVat)} ${strings.inVatShort}`}
					</span>
				</TextLinkButtonWithExpandIcon>
				<Collapse in={isExpanded}>
					<div className='df-col gap-4'>
						<span style={{ fontSize: MinorFontSize }}>
							{`${strings.unitListPrice}: ${formatCurrency(line.unitListPriceExVat)} (${strings.exVatShort}) | ${formatCurrency(line.unitListPriceInVat)} (${
								strings.inVatShort
							})`}
						</span>
						<span style={{ fontSize: MinorFontSize }}>
							{`${strings.discount}: ${line.discountPercentage.toFixed(2)}% | ${formatCurrency(line.lineDiscountValueExVat)} (${
								strings.exVatShort
							}) | ${formatCurrency(line.lineDiscountValueInVat)} (${strings.inVatShort})`}
						</span>
						<span style={{ fontSize: MinorFontSize }}>{`${strings.vat}: ${line.vatPercentage}% | ${formatCurrency(line.lineVatValue)}`}</span>
					</div>
				</Collapse>
			</div>
		</div>
	);
};
